import React from 'react';
import { Navbar, Feed } from './components';
import './styles/index.css';

function App() {
  return (
    <>
      <Navbar />
      <Feed />
    </>
  );
}

export default App;
